module.exports = __webpack_public_path__ + "img/vg.0f6fd174.svg";